import { atom } from 'jotai';

export const uiStateAtomReachedProjectPageContent = atom(false);
